const relatorio_de_execucao_de_reordenamento = {
  path: "/relatorio-de-execucao-de-reordenamento",
  redirect: "/relatorio-de-execucao-de-reordenamento",
  meta: {
    breadCrumb:
      "Processo de Matrículas - Emitir Relatório de Execução do Reordenamento",
  },
  children: [
    {
      path: "/relatorio-de-execucao-de-reordenamento",
      name: "relatorio_de_execucao_de_reordenamento",
      component: () =>
        import(
          "@/views/RelatorioDeExecucaoDeReordenamento/RelatorioDeExecucaoDeReordenamentoHome.vue"
        ),
    },
  ],
};

export { relatorio_de_execucao_de_reordenamento };
